import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import PersonalDetailsForm from "@/components/application/PersonalDetailsForm";
import ApplicationStepper from "@/components/application/ApplicationStepper";

const PersonalDetailsPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />

        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Personal Details
        </h1>
        <p className="text-gray-600 mb-8 text-center">
          Complete your personal information to finalize your application
        </p>

        <div className="max-w-2xl mx-auto">
          <PersonalDetailsForm />
        </div>
      </div>
    </AppLayout>
  );
};

export default PersonalDetailsPage;
